import { useState } from "react";
import { Modal } from "react-bootstrap";
import { BaseURL } from "../../../constants/enum/baseURL.emum";

const Doc5GenPdf = (props: { doc3: number; type: string }) => {
  const { doc3, type } = props;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  return (
    <>
      <a
        className="btn  btn-primary btn-sm"
        href={`${BaseURL.BASE_URL}/testdoc5/${doc3}`}
        target="_blank"
        rel="noreferrer"
      >
        รายงานการส่ง {type === "tqf" ? "มคอ." : "อชว."}5 | R-2 ของรายวิชา
      </a>
      {/* <button className="btn  btn-primary ms-1" onClick={handleShow}>
        รายงานการส่ง {type === "tqf" ? "มคอ." : "อชว."}5 ของรายวิชา
      </button> */}
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เอกสาร {type}5
          </Modal.Title>
        </Modal.Header>{" "}
        <Modal.Body>
          <iframe
            className="container-fluid"
            src={encodeURI(`${BaseURL.BASE_URL}/gendoc5/${doc3}`)}
            frameBorder="0"
            style={{ height: "100vh" }}
            title={`${type === "tqf" ? "มคอ." : "อชว."}5`}
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Doc5GenPdf;
